import React, { useEffect, useState } from "react";
import { NavigationContainer } from "@react-navigation/native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { linking } from "routers/linking";
import { navigationRef } from "routers/helper";
import { webPagesTitle } from "routers/webPagesTitle";
import DrawerContent from "routers/drawerContent";
import Lead from "routers/stacks";

import { Loading } from "components";
import Toast from "components/toast";

import { InsertMobile, VerifyCode } from "screens";

import { useRecoilValue } from "recoil";
import { useGetAuth } from "clients/apis";
import { authAtom, storage } from "stores";

import { colors, sizes } from "assets/constants";
import { sn } from "utils";

const Stack = createNativeStackNavigator<Routes>();
const Drawer = createDrawerNavigator<Routes>();

const Navigator = () => {
  const [initialLoading, setInitialLoading] = useState(true);
  const auth = useRecoilValue(authAtom);

  const { refetch: getAuth } = useGetAuth();

  useEffect(() => {
    storage.get().then((storedUser) => {
      if (storedUser?.token) {
        getAuth().then((result: any) => {
          if (result.status === "success") {
            setInitialLoading(false);
            return;
          } else {
            if (result?.error?.response?.status === 401) {
              setInitialLoading(false);
              return;
            }

            // setConnectionError(true);
          }
        });
      } else {
        setInitialLoading(false);
      }
    });
  }, []);

  if (initialLoading) {
    return <Loading />;
  }

  return (
    <NavigationContainer linking={linking} ref={navigationRef}>
      {auth?.token ? (
        <Drawer.Navigator
          drawerContent={DrawerContent}
          screenOptions={() => {
            return {
              sceneContainerStyle: { backgroundColor: colors.bg.screen },
              headerShown: false,
              swipeEnabled: false,
              drawerType: sn("front", "front", "front", "permanent"),
              drawerPosition: "right",
              drawerStyle: {
                width: sizes.drawerW,
                borderLeftWidth: 0.5,
                borderLeftColor: colors.black + "11",
              },
            };
          }}
        >
          <Drawer.Screen name="lead" component={Lead} />
        </Drawer.Navigator>
      ) : (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
          <Stack.Screen
            name={"insert_mobile"}
            component={InsertMobile}
            options={{ title: webPagesTitle.insert_mobile }}
          />
          <Stack.Screen
            name={"verify_code"}
            component={VerifyCode}
            options={{ title: webPagesTitle.verify_code }}
          />
        </Stack.Navigator>
      )}
      <Toast.Provider />
    </NavigationContainer>
  );
};

export default Navigator;
